export default __webpack_public_path__ + "static/media/olamide-abdul-v2Podcast.6b39b24c.png";